// extracted by mini-css-extract-plugin
module.exports = {"w10os1y8":"w10os1y8"};